import React from "react";

import ReusableTest from "../ReusableComponent";

function Test() {
  return (
    <ReusableTest
      category="sgd"
      path="get-test-post-sgd"
      beginningCounterCount={10}
      playingCounterCount={5}
      recordingTotalCount={120}
    ></ReusableTest>
  );
}

export default Test;
